import { useContext } from 'react';
import FiltersMenu from '@/FiltersMenu/FiltersMenu';
import AppliedFilters from '@/MainLayout/AppliedFilters';
import FacetDataContext from '~/contexts/FacetDataContext';
import useTrackRendered from '~/hooks/useTrackRendered';
import { Aside } from './Filters.styles';

export default function Filters() {
  useTrackRendered(
    'srch-impossible-facets',
    useContext(FacetDataContext).didExpandMenu
  );

  return (
    <Aside data-qa="filters-aside">
      <div className="sticky top-0 z-[1]">
        <AppliedFilters />
      </div>
      <FiltersMenu />
    </Aside>
  );
}
